/**
 * 定义action-type
 */
export const ADD_TODO = "ADD_TODO"
export const RECEIVE_POSTS = "RECEIVE_POSTS"
export const CHANGE_REACHBOTTOM = 'CHANGE_REACHBOTTOM'
export const CHANGE_LOADALLDATA = 'CHANGE_LOADALLDATA'
export const CHANGE_ERRORCODE = 'CHANGE_ERRORCODE'
export const CHANGE_LOADING = 'CHANGE_LOADING'
export const HELLOSAGA = 'HELLOSAGA'
export const FETCH_SUCCEEDED = 'FETCH_SUCCEEDED'



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js